<template>
    <v-card class="ma-2 time-card">
        <v-card-text>
            <div class="recording-title">Medical Leave</div>
            <v-divider class="mb-3"></v-divider>
            <v-form v-model="formValid" ref="form" lazy-validation novalidate>
                <v-layout align-center>
                    <v-flex xs1>
                        <div class="mx-3">
                            <v-btn flat color="black" disabled class="add-medical-leave-btn">
                                {{getMedicalLeaveDuration(this.medicalLeaveStartDate, this.medicalLeaveEndDate)}}
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="!isEditEnabled" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="medical-leave-date" slot="activator" label="Start date" v-model="medicalLeaveStartDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="medicalLeaveStartDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="!isEditEnabled" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="medical-leave-date" slot="activator" label="End date" v-model="medicalLeaveEndDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="medicalLeaveEndDate" :allowed-dates="medicalLeaveAllowedDays" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs4>
                        <div class="mx-3">
                            <v-text-field :disabled="!isEditEnabled" v-model="medicalLeaveComment" label="№ of Sick list" 
                                required :rules="commentRule"></v-text-field>
                        </div>
                    </v-flex>
                    <v-flex class="text-xs-center" xs1>
                        <v-btn :disabled="!isEditEnabled" flat color="black" @click.stop.prevent="addNewMedicalLeave()" slot="activator" class="add-medical-leave-btn">
                            <v-icon color="indigo">mdi-plus</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
            <template v-for="medicalLeave in medicalLeaves">
                <v-divider :key="`divider-${medicalLeave.id ? `id${medicalLeave.id}` : `obsId${medicalLeave.observationId}`}`" class="mb-3"></v-divider>
                <v-layout :key="`layout-${medicalLeave.id ? `id${medicalLeave.id}` : `obsId${medicalLeave.observationId}`}`" align-center>
                    <v-flex xs1>
                        <div class="mx-3">
                            <v-btn flat color="black" disabled class="add-medical-leave-btn">
                                {{getMedicalLeaveDuration(medicalLeave.startDate, medicalLeave.endDate)}}
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                         <div class="mx-3">  
                            <v-menu :disabled="!isEditEnabled" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="medical-leave-date" slot="activator" label="Start date" v-model="medicalLeave.startDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="medicalLeave.startDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="!isEditEnabled" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="medical-leave-date" slot="activator" label="End date" v-model="medicalLeave.endDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="medicalLeave.endDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs4>
                        <div class="mx-3">
                            <v-text-field v-model="medicalLeave.sickListNumber" label="№ of Sick list"></v-text-field>
                        </div>
                    </v-flex>
                    <v-flex class="text-xs-center" xs1>
                        <v-btn :disabled="!isEditEnabled" flat color="black" @click="removeExistMedicalLeave(medicalLeave)" slot="activator" class="add-medical-leave-btn">
                            <v-icon color="indigo">mdi-delete</v-icon>
                        </v-btn>
                        <v-btn :disabled="!isEditEnabled" flat color="black" @click="editExistMedicalLeave(medicalLeave)" slot="activator" class="add-medical-leave-btn">
                            <v-icon color="indigo">mdi-content-save</v-icon>
                        </v-btn>   
                    </v-flex>
                </v-layout>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
    import moment from 'moment';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'EmployeeMedicalLeave',
        data() {
            return {
                medicalLeaveStartDate: null,
                medicalLeaveEndDate: null,
                medicalLeaveComment: '',
                formValid: false,
                dateRules: [ date => !!date || 'Choose date' ],
                commentRule: [ comment => (comment && !!comment.trim()) || 'Enter number of Sick list' ],
                observationId: 0
            };
        },
        computed: {
            ...mapGetters({
                employee: 'getEmployee',
                medicalLeaves: 'getAllMedicalLeaves'
            }),
            isEditEnabled() {
                const { employee } = this.$store.state.employees;
                return !employee.archived || (employee.archived && employee.duplicated);
            }
        },
        methods: {
            ...mapActions([
                'addMedicalLeave',
                'editMedicalLeave',
                'removeMedicalLeave'
            ]),
            addNewMedicalLeave() {
                if (this.$refs.form.validate()) {
                    const medicalLeave = {
                        observationId: this.observationId++,
                        startDate: this.medicalLeaveStartDate,
                        endDate: this.medicalLeaveEndDate,
                        sickListNumber: this.medicalLeaveComment,
                        user: {
                            userId: this.employee.userId
                        }
                    };

                    this.addMedicalLeave(medicalLeave).then(() => {
                        this.$refs.form.reset();
                    });
                }
            },
            removeExistMedicalLeave(medicalLeave) {
                this.removeMedicalLeave(medicalLeave);
            },
            editExistMedicalLeave(medicalLeave) {
                this.editMedicalLeave(medicalLeave);
            },
            medicalLeaveAllowedDays(date) {
                return moment(date).isSameOrAfter(moment(this.medicalLeaveStartDate));
            },
            getMedicalLeaveDuration(startDate, endDate) {
                return startDate && endDate
                    ? moment.duration(moment(endDate)
                        .diff(moment(startDate))).asDays() + 1
                    : 0;
            }
        }
    };
</script>

<style scoped>
.recording-title {
  font-size: 20px;

  padding-top: 5px;
  padding-bottom: 5px;
}

.add-medical-leave-btn >>> .btn__content {
  padding: 0;
}

.add-medical-leave-btn {
  min-width: 32px;
  width: 32px;
  min-height: 32px;
  height: 32px;

  margin: 6px 0px 14px 6px;
  
  background-color: #ced2e6 !important;
  font-size: 18px;
}

.medical-leave-date >>> .input-group__input input {
  font-size: 14px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/reusable/EmployeeMedicalLeave.vue